/**
 * Novavax COVID-19 Vaccine Study (65+) - Self-Contained Module
 *
 * This module contains all configuration for the Novavax COVID-19 Vaccine Study
 * in a single, easily maintainable location.
 */

import { defineStudy } from "./registry";
import { novavax65EligibleZipCodes } from "../../../data/vaccine-study-zipcodes/novavax65ZipCodes";
import { novavaxCovid65ScreeningQuestions } from "../../../data/pre-screener-config/NovavaxCovid65Screener";

/**
 * Common question IDs that will be asked before zipcode
 * and should be filtered out of study-specific questions
 */
const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * Novavax COVID-19 Vaccine Study (65+)
 *
 * Priority: 6 (Sixth priority - after all flu studies and Moderna COVID)
 * Trial ID: VCOVIV31865
 * Location: Multiple regions (OH, KY, IA, NE, LA) - 237 zipcodes
 *
 * Key criteria:
 * - Age 65+
 * - Previously vaccinated against COVID-19
 * - No COVID vaccine in past 3 months
 * - No COVID infection in past 3 months
 * - No recent vaccines (2 weeks)
 * - No history of vaccine anaphylaxis
 * - No active cancer (past 3 years)
 * - No immunosuppressants (past 3 months)
 * - No blood products (past 3 months)
 */
export const novavaxCovid65Study = defineStudy({
  id: "novavax-covid-65",
  name: "Novavax COVID-19 Vaccine Study",
  trialId: "VCOVIV31865",
  priority: 6,

  // Convert readonly array to regular array for compatibility
  eligibleZipCodes: Array.from(novavax65EligibleZipCodes),

  // All questions including common ones (will be filtered automatically)
  questions: novavaxCovid65ScreeningQuestions,

  // Questions to filter out (already asked in common stage)
  commonQuestionIds: COMMON_QUESTION_IDS,

  // Required common answer values (age 65+)
  commonAnswerRequirements: {
    age_eligibility: ["65_or_older"],
  },

  metadata: {
    sponsor: "Novavax",
    description:
      "Investigating an investigational COVID-19 vaccine for adults aged 65 and older at high risk for severe COVID-19",
  },
});
